import { getUserState } from '@carvana/core-auth';
import Cookie from '@carvana/stc-cookie';
import { datadogRum } from '@datadog/browser-rum';

declare global {
  interface Window {
    Cypress: unknown;
  }
}

const initializeDataDog = () => {
  const isClient = typeof window === 'object';
  const { user } = getUserState();
  let existingCypress;
  if (isClient) {
    existingCypress = window.Cypress;
    window.Cypress = undefined;
  }

  datadogRum.init({
    applicationId: 'c0e19456-086b-48eb-b954-ea6abf661dcf',
    clientToken: 'pub1d8c8908f469710592832a49e98cf269',
    site: 'datadoghq.com',
    service: 'stc-ui',
    env: `${process.env.CARVANA_APP_ENVIRONMENT}`,
    version: `${process.env.APP_VERSION}`,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sampleRate: 100,
    trackInteractions: true,
    trackFrustrations: true,
    defaultPrivacyLevel: 'mask-user-input'
  });

  datadogRum.setUser({
    id: user.user_id,
    bcid: Cookie.getBcId(),
  });

  datadogRum.startSessionReplayRecording();
  datadogRum.addAction('Rum Initialized');

  if (isClient) {
    window.Cypress = existingCypress;
  }
};

export { initializeDataDog };
